export const filterNonMatchingValues = (obj1, obj2) => {
    return Object.keys(obj1).reduce((result, key) => {
      if (!obj2.hasOwnProperty(key) || obj1[key] !== obj2[key]) {
        result[key] = obj1[key];
      }
      return result;
    }, {});
  };
  